import React, {useState} from 'react'
import {Card, Button} from 'antd'
import ReactCodeInput from 'react-verification-code-input';
import UserService from "../../API/user/UserService"
import {useHistory} from 'react-router-dom';
import "./Verify.css"
import Navbar from '../../components/layout/Navbar';
import Footer3 from '../../components/layout/Footer3';

function Otp(props) {
    const [verified, setVerified] = useState(true)
    const [loading, setLoading] = useState({isLoading: false, feedback: null})
    const [code, setCode] = useState([])
    
    var codes = [];

    const email = props?.location?.state?.email || '';
    const token = props?.location?.state?.token || '';

    const submit = () => {
        setLoading({isLoading: true, feedback: null});
       
        var otp = parseInt(code.join(''));

        UserService.verifyOtp(otp, email, token)
            .then((resp) => {
                setLoading({isLoading: false, feedback: "successfully verified"})
                const response = JSON.stringify(resp.data);
                localStorage.setItem('UserData', response);
                setVerified(false)
                setTimeout(() => {
                    window.location.href = "/"
                }, 2000)
            })
            .catch((err) => {
                setLoading({isLoading: false, feedback: err?.response?.data?.message || err?.message || 'Could not login at this time'})
           
            });
    }

    const Resend = () => {
        setLoading({isLoading: true, feedback: null})
        UserService.resendOtp(email, token)
            .then((resp) => {
                console.log(resp)
                setLoading({isLoading: false, feedback: "Code Resent To Email"})
            })
            .catch((err) => {
                setLoading({isLoading: false, feedback: err?.response?.data?.message || err?.message || 'Could not resend code at this time'})
           
            });
    }
   
    return (
        <>
            <Navbar />
            <div className='auth-page'>
                <div className='auth-card-wrapper'>
                    {verified ? (
                        <Card className='auth-card'>
                            <h1 className='auth-title'>OTP Verification</h1>
                            <p className='auth-subtitle'>
                                We just emailed you. Please check your email for the One Time Pin.
                            </p>
                            
                            <p className='auth-email-highlight'>{email}</p>

                            <div className='auth-otp-wrapper'>
                                <ReactCodeInput
                                    values={code}
                                    onChange={(e) => {
                                        codes.push(e)
                                        setCode(codes)
                                    }}
                                />
                            </div>

                            <Button
                                onClick={submit}
                                type="primary"
                                className='auth-btn'
                            >
                                {loading.isLoading ? (
                                    <div className="lds-facebook"><div></div><div></div><div></div></div>
                                ) : (
                                    <>Verify <span>&#8594;</span></>
                                )}
                            </Button>

                            <Button
                                onClick={Resend}
                                type="primary"
                                className='auth-btn'
                                style={{marginTop: '12px', backgroundColor: '#f5f5f5', color: '#333'}}
                            >
                                {loading.isLoading ? (
                                    <div className="lds-facebook"><div></div><div></div><div></div></div>
                                ) : "Resend Code"}
                            </Button>

                            {loading.feedback && (
                                <p className='auth-feedback'>{loading.feedback}</p>
                            )}
                        </Card>
                    ) : (
                        <Card className='auth-card auth-success-card'>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <img
                                    style={{width: '120px', height: '120px'}}
                                    src="check.png"
                                    alt="Success"
                                    className='auth-success-icon'
                                />
                            </div>
                            <p className='auth-success-message'>OTP successfully verified</p>
                        </Card>
                    )}
                </div>
            </div>
            <Footer3 />
        </>
    )
}

export default Otp;
